import { TableCell, TableHead, TableRow } from "@mui/material";

const AllActiveOffersTableHead = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                <TableCell sx={styles.defaultTextStyle}>Marka i model</TableCell>
                <TableCell sx={styles.defaultTextStyle}>Naslov zahteva</TableCell>
                <TableCell sx={styles.defaultTextStyle}>Opis</TableCell>
                <TableCell sx={styles.defaultTextStyle}>Status</TableCell>
            </TableRow>
        </TableHead>
    );
};

export default AllActiveOffersTableHead;
const styles = {

    defaultTextStyle: {
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: "24px",
        color: "rgba(0,0,0,0.87)",
    },
};